import { useEffect, type ReactNode } from "react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AppLayout } from "@/components/layout/AppLayout";

const LOGIN_PATH = "/login";

function TelaCarregando() {
  return (
    <div
      className="flex min-h-screen items-center justify-center bg-background"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-3 text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
        <span className="text-sm">Carregando sessão…</span>
      </div>
    </div>
  );
}

export function AuthGate({ children }: { children: ReactNode }) {
  const { autenticado, carregando } = useAuth();
  const navigate = useNavigate();
  const location = useRouterState({ select: (s) => s.location });
  const isLogin = location.pathname === LOGIN_PATH;

  useEffect(() => {
    if (carregando) return;
    if (!autenticado && !isLogin) {
      void navigate({
        to: LOGIN_PATH,
        search: { redirect: location.href },
        replace: true,
      });
    }
  }, [carregando, autenticado, isLogin, location.href, navigate]);

  if (carregando) return <TelaCarregando />;

  if (isLogin) return <>{children}</>;

  if (!autenticado) return <TelaCarregando />;

  return <AppLayout>{children}</AppLayout>;
}
